/**
 * Main JavaScript file for the Lastag theme.
 *
 * @package Lastag
 * @version 1.0.0
 */

import { initializeCounters } from './counters.js';
import { initializeRotator } from './rotator.js';
import { initializeParallax } from './parallax.js';
import { initializeMobileMenu } from './mobile-menu.js';
import { initializeGallery } from './gallery.js';
import { initializeHeaderScroll } from './header-scroll.js';
import { initializeLightbox } from './lightbox.js';
import { initializeFloating } from './floating.js';

(function($) {
    'use strict';

    $(document).ready(function() {
        initializeCounters();
        initializeRotator();
        initializeParallax();
        initializeMobileMenu();
        initializeGallery();
        initializeHeaderScroll();
        initializeLightbox();
        initializeFloating();
    });

})(jQuery);